import EventBus from "./event-bus";
import { EVENTS } from "./constants";
import ShopService from "./shop-service";
import UrlService from "./url-service";
import _ from "lodash";

let defaultTheme = {
	color1: "#27cde6",
	color1d: "#1d6f7c",
	color2: "#fe754a",
	color2d: "#ba4021",
};

export default {
	defaultTheme,
	themeElement,
	getMarkerIcon,
	getMapStyles,
	getSisterShopsMapStyles,
};

init();

function init() {
	EventBus.$on(EVENTS.shopChanged, updateTheme);
}

function getMarkerIcon(shop = ShopService.shop) {
	let icon = null;
	if (typeof google !== "undefined" && shop && shop.info && shop.info.map && shop.info.map.marker && shop.Logo) {
		icon = {
			url: UrlService.imagePath(shop.ShopId, shop.Logo),
			scaledSize: new google.maps.Size(32, 32),
		};
	}
	return icon;
}

function getSisterShopsMapStyles() {
	let mapStyles = [
		{
			featureType: "administrative",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "administrative.country",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "administrative.country",
			elementType: "labels.text.fill",
			stylers: [
				{
					color: "#6b6b6b",
				},
			],
		},
		{
			featureType: "administrative.province",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "administrative.locality",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "administrative.neighborhood",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "administrative.neighborhood",
			elementType: "geometry",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "landscape.natural",
			elementType: "geometry.fill",
			stylers: [
				{
					visibility: "on",
				},
				{
					color: "#e0efef",
				},
			],
		},
		{
			featureType: "poi",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi",
			elementType: "geometry.fill",
			stylers: [
				{
					visibility: "on",
				},
				{
					hue: "#1900ff",
				},
				{
					color: "#c0e8e8",
				},
			],
		},
		{
			featureType: "poi.business",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi.government",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "poi.medical",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi.park",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "poi.place_of_worship",
			elementType: "all",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "poi.school",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "road",
			elementType: "geometry",
			stylers: [
				{
					lightness: 100,
				},
				{
					visibility: "simplified",
				},
			],
		},
		{
			featureType: "road",
			elementType: "labels",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "road.local",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "transit.line",
			elementType: "geometry",
			stylers: [
				{
					visibility: "on",
				},
				{
					lightness: 700,
				},
			],
		},
		{
			featureType: "transit.station.bus",
			elementType: "all",
			stylers: [
				{
					visibility: "simplified",
				},
			],
		},
		{
			featureType: "transit.station.rail",
			elementType: "all",
			stylers: [
				{
					visibility: "on",
				},
			],
		},
		{
			featureType: "water",
			elementType: "all",
			stylers: [
				{
					color: "#7dcdcd",
				},
			],
		},
	];
	return mapStyles;
}
function getMapStyles(shop = ShopService.shop) {
	let styles = null;
	if (shop && shop.info && shop.info.map && shop.info.map.grey) {
		styles = [
			{ elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
			{ elementType: "labels.icon", stylers: [{ visibility: "off" }] },
			{ elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
			{ elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
			{
				featureType: "administrative.land_parcel",
				elementType: "labels.text.fill",
				stylers: [{ color: "#bdbdbd" }],
			},
			{ featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
			{ featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
			{ featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
			{ featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
			{ featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
			{ featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
			{ featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
			{ featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
			{ featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
			{ featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
			{ featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
			{ featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
			{ featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
		];
	}
	return styles;
}

function getConversionObject() {
	return {
		fromColors: _.mapValues(defaultTheme, val => hexToRgb(val)),
		toColors: _.mapValues(ShopService.shop.Theme, val => hexToRgb(val)),
	};
}

function themeElement($el) {
	$("style", $el).each((i, style) => themeStyleTag(style));
}

function themeStyleTag(styleTag) {
	processSheet(styleTag.sheet, getConversionObject());
}

let rulesCache = [];
function updateTheme() {
	let conversion = getConversionObject();
	for (let i in document.styleSheets) {
		replaceRootVariables();
		processSheet(document.styleSheets[i], conversion);
	}
}

function replaceRootVariables() {
	for (let colorVariable in defaultTheme) {
		let fromColor = defaultTheme[colorVariable];
		let toColor = ShopService.shop.Theme[colorVariable] || fromColor;
		document.documentElement.style.setProperty("--" + colorVariable, toColor);
	}
}

function processSheet(sheet, conversion) {
	try {
		for (let i in sheet.cssRules) {
			let rule = sheet.cssRules[i];
			processRule(rule, conversion);
			if (rule.cssRules) {
				processSheet(rule, conversion);
			}
		}
	} catch (ex) {}
}

function processRule(rule, conversion) {
	if (isCached(rule)) {
		processCachedRule(rule, conversion);
	} else if (rule.style) {
		let transforms = {};
		let k = 0;
		while (rule.style[k]) {
			let prop = rule.style[k];
			for (let colorName in conversion.fromColors) {
				let fromColor = conversion.fromColors[colorName];
				let toColor = conversion.toColors[colorName] || fromColor;
				let value = rule.style[prop];
				// if (rule.style[prop] == fromColor){
				if (_.includes(value, fromColor)) {
					rule.style.setProperty(
						prop,
						value.replace(fromColor, toColor),
						rule.style.getPropertyPriority(prop)
					);
					// store each rule property modified by the theme
					transforms[prop] = { colorName, toColor };
				}
			}
			k++;
		}
		addToCache(rule, transforms);
	}
}

function processCachedRule(rule, conversion) {
	let transforms = cache[rule.CACHE_ID].transforms;
	for (let prop in transforms) {
		let colorName = transforms[prop].colorName;
		let value = rule.style[prop];
		let toColor = conversion.toColors[colorName] || conversion.fromColors[colorName];

		rule.style.setProperty(
			prop,
			value.replace(transforms[prop].toColor, toColor),
			rule.style.getPropertyPriority(prop)
		);
		transforms[prop].toColor = toColor;
	}
}

let cache = {};
let CACHE_COUNTER = 1;
function addToCache(rule, transforms) {
	rule.CACHE_ID = CACHE_COUNTER++;
	cache[rule.CACHE_ID] = { rule, transforms };
}

function isCached(rule) {
	return rule.CACHE_ID in cache;
}

// converts '#fe754a' to 'rgb(254,117,74)'
function hexToRgb(hex = "") {
	if (hex[0] != "#") return hex;
	var bigint = parseInt(hex.substr(1), 16);
	var r = (bigint >> 16) & 255;
	var g = (bigint >> 8) & 255;
	var b = bigint & 255;

	return "rgb(" + [r, g, b].join(", ") + ")";
}
